module.exports = function toggleLifeThreatening() {
	var selectedDietaryNeeds = window.jQuery('input[name=dietaryNeeds]:checked');
	var enableLifeThreatening = false;

	selectedDietaryNeeds.each(function () {
		if (window.jQuery(this).data('lifethreatening') === true) {
			enableLifeThreatening = true;
		}
	});

	if (enableLifeThreatening) {
		window.jQuery('#lifeThreatening').removeAttr('disabled');
	} else {
		window.jQuery('#lifeThreatening').attr('disabled', 'disabled');
		window.jQuery('#lifeThreatening').val('');
	}
};
